import { render, staticRenderFns } from "./ParticaMenu.vue?vue&type=template&id=4f2554ee&"
import script from "./ParticaMenu.vue?vue&type=script&lang=ts&"
export * from "./ParticaMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports